<template>
  <div>
    <!-- Companies List -->
    <div class="gap-12 grid md:grid-cols-4">
      <div v-for="company in companies" :key="company.id" class="bg-white flex flex-col shadow-sm rounded-lg"
        style="min-height: 315px;">
        <div class="flex-grow text-center p-3 mb-auto">
          <img :src="company.company_logo" :alt="company.company_name" class="img-fluid mb-3 mx-auto mt-3"
            style="height: 100px; width: 200px" />
          <h5 class="font-extrabold fw-bold mb-5 text-3xl text-dark">
            خصم
            <span>
              {{ company.discount_type === "percentage"
              ? Math.floor(company.discount_value) + "%"
              : Math.floor(company.discount_value) + " جنيه" }}
            </span>
          </h5>
          <p class="text-dark mb-6">
            {{ company.description }}
          </p>
        </div>

      <!-- Copy Button -->
      <div v-if="company.code" class="copy-button-container">
          <button
            :class="['custom-copy-button', copiedCode === company.code ? 'copied' : '']"
            @click="handleCopy(company.code)"
          >
          <span class="button-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
            </span>
            <span class="button-text">
              <span v-if="copiedCode === company.code">تم نسخ الكود</span>
              <span v-else>{{ company.code }}</span>
            </span>

          </button>
        </div>

        <!-- Button always at the bottom -->
        <div class="p-3 mb-3 px-5">
          <a :href="company.company_url" target="_blank" rel="noopener noreferrer" class="custom-button">
            احصل
          </a>
        </div>
      </div>
    </div>
    <nav v-if="pagination.last_page > 1" class="flex justify-center items-center space-x-4 mt-6">
      <div class="flex justify-center items-center mt-6">
        <vs-pagination :total="pagination.last_page" v-model="pagination.current_page" @change="onPageChange"
          :prev-icon="$vs.rtl ? 'arrow_forward' : 'arrow_back'" :next-icon="$vs.rtl ? 'arrow_back' : 'arrow_forward'" />
      </div>
    </nav>
  </div>
</template>

<script>
import Axios from "axios";
import copyText from '@/mixins/helper.js';

export default {
  mixins: [copyText],
  data() {
    return {
      companies: [],
      copiedCode: null,
      pagination: {
        current_page: 1,
        last_page: 1,
        next_page_url: null,
      },
    };
  },
methods: {
  async fetchCompanies(url = null) {
    const perPage = 8;
    const endpoint = url || process.env.VUE_APP_BASE_URL + `marketplace?page=${this.pagination.current_page}&perPage=${perPage}`;
    const { data } = await Axios.get(endpoint);

    if (data.response.success) {
      this.companies = [...data.response.feed.data];
      this.pagination = {
        current_page: data.response.feed.current_page,
        last_page: data.response.feed.last_page,
        next_page_url: data.response.feed.next_page_url,
        total: Math.ceil(data.response.feed.total / data.response.feed.per_page),
      };
    }
  },
  onPageChange(page) {
    // Update current page and fetch data
    this.pagination.current_page = page;
    this.fetchCompanies();
  },
  handleCopy(code) {
      navigator.clipboard.writeText(code).then(() => {
        this.copiedCode = code;
        setTimeout(() => {
          this.copiedCode = null; // Reset state after 3 seconds
        }, 3000);
      });
    },
},
  mounted() {
    this.fetchCompanies();
  },
};
</script>

<style>
.card {
  border: 1px solid #f1f1f1;
  border-radius: 10px;
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-5px);
}

.custom-button {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: bold;
  padding: 0.75rem;
  font-size: 1.25rem;
  color: #4400AF; /* Text Color */
  background-color: white; /* Background Color */
  border: 1px solid #4400AF; /* Border Color */
  border-radius: 8px;
  transition: all 0.3s ease-in-out; /* Smooth Hover Transition */
}

.custom-button:hover {
  background-color: #4400AF; /* Background Color on Hover */
  color: white; /* Text Color on Hover */
  border-color: #4400AF; /* Keep Border Color on Hover */
}
.custom-copy-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color:  #F8F8F8;
  font-size: 1rem;
  border: 1px solid #CCCCCC;
  padding: 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  width: 90%;
  margin: 0 auto;
}

.custom-copy-button.copied {
  background-color: #218838;
  color: #FFF;
}

.button-icon {
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.button-text {
  display: inline-flex;
  align-items: center;
  font-size: larger;
}

</style>
